import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/ajuizamento'
const APICore = process.env.APIBaseURLCore

const GetAll = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, filters, config)
const GetAllCardsReport = (dataFilters, limit, index, config = {}) => APIClient.post(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, dataFilters, config)
const ExportAllCardsReport = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, dataFilters, config)

const ReportAjuizamentoRepository = {
  GetAll,
  GetAllCardsReport,
  ExportAllCardsReport
}

export default ReportAjuizamentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/reportAjuizamento.js